import { apolloClient, EntityDescriptor, EntityEditorPage, EntityEditorPageProps, EntityTablePage, EntityTablePageProps, EntityTablePageReducers, EntityTablePageState } from "@crispico/foundation-react";
import { OverrideableElement, TabRouterPane } from "@crispico/foundation-react/components/TabbedPage/TabbedPage";
import { FieldType } from "@crispico/foundation-react/entity_crud/FieldType";
import { ReduxReusableComponents } from "@crispico/foundation-react/reduxReusableComponents/ReduxReusableComponents";
import { Button } from "semantic-ui-react";
import { GENERATE_VAC_KEYS_PER_EQUIPMENT, REPOPULATE_ASSOCIATION_TABLE_BASED_ON_EQUIPMENT_RESOURCE_FILTER, TEMP_GENERATE_AND_SEND } from "./queries";
import { entityDescriptors } from "@crispico/foundation-react/entity_crud/entityCrudConstants";

export class VacKeyGroupEntityDescriptor extends EntityDescriptor {

    constructor() {
        super({ name: "VacKeyGroup", miniFields: ["name"] });
    }

    protected customize() {
        this.addFieldDescriptor({ name: "equipmentResourceFilter", type: FieldType.filter, entityName: "EquipmentResource", filterable: false, sortable: false })

        this.infoEditor.wrappedComponentClass = class extends EntityEditorPage<EntityEditorPageProps> {
            protected getExtraTabPanes(): (TabRouterPane | null)[] {
                return [
                    ...super.getExtraTabPanes(),
                    {
                        ...this.createOneToManyTabPane("VacKeyGroup_equipmentResources__EquipmentResource_vacKeyGroups", "vacKeyGroup"),
                        menuItemProps: { content: entityDescriptors["EquipmentResource"].getLabel(true), icon: entityDescriptors["EquipmentResource"].icon }
                    },
                    {
                        ...this.createOneToManyTabPane("VacKey_vacKeyGroups__VacKeyGroup_vacKeys", "vacKeyGroup", {}),
                        menuItemProps: { content: entityDescriptors["VacKey"].getLabel(true), icon: entityDescriptors["VacKey"].icon }
                    }
                ];
            }
        }
    }

    renderTable() {
        return <VacKeyGroupTablePageRRC {...super.renderTable().props} ref={this.entityTablePage} />;
    }
}

class VacKeyGroupTablePage extends EntityTablePage<EntityTablePageProps> {

    private async repopulateAssociationTableBasedOnEquipmentResourceFilter() {
        (await apolloClient.mutate({
            mutation: REPOPULATE_ASSOCIATION_TABLE_BASED_ON_EQUIPMENT_RESOURCE_FILTER,
            context: { showSpinner: false }
        }))
    }

    private async generateVacKeysPerEquipment() {
        const result = (await apolloClient.query({
            query: GENERATE_VAC_KEYS_PER_EQUIPMENT,
            context: { showSpinner: false }
        })).data["vacKeyGroupService_generateVacKeysPerEquipment"];
        console.log(result);
    }

    private async generateAndSendVacKeysPerEquipment() {
        (await apolloClient.mutate({
            mutation: TEMP_GENERATE_AND_SEND,
            context: { showSpinner: false }
        }))
    }

    protected preRenderButtons(params: {}): Array<OverrideableElement> {
        return [{
            element: <Button key="repopulateAssociationTableBasedOnEquipmentResourceFilter" positive onClick={async () => await this.repopulateAssociationTableBasedOnEquipmentResourceFilter()}>{_msg("VacKeyGroup.repopulateAssociationTableBasedOnEquipmentResourceFilter.label")}</Button>
        }, {
            element: <Button key="generateVacKeysPerEquipment" positive onClick={async () => await this.generateVacKeysPerEquipment()}>{_msg("VacKeyGroup.generateVacKeysPerEquipment.label")}</Button>
        }, {
            element: <Button key="generateAndSendVacKeysPerEquipment" positive onClick={async () => await this.generateAndSendVacKeysPerEquipment()}>{_msg("VacKeyGroup.generateAndSendVacKeysPerEquipment.label")}</Button>
        }];
    }
}

const VacKeyGroupTablePageRRC = ReduxReusableComponents.connectRRC(EntityTablePageState, EntityTablePageReducers, VacKeyGroupTablePage);
